module.exports = __webpack_public_path__ + "media/A_MX_Avatar Design_Loop.712728cc.ogg";